import { render, staticRenderFns } from "./SelectProfile.vue?vue&type=template&id=4145fd26"
import script from "./SelectProfile.vue?vue&type=script&lang=js"
export * from "./SelectProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports